import React from "react";
import { Check } from "lucide-react";

const pad3 = (n) => String(n).padStart(3, "0");

// Shared public-seat grid (seats 11-100 only; reserved 1-10 are never in the data).
// available -> selectable; taken -> greyed with the holder's handle; held -> greyed "HELD"
// and unselectable. Used by both the /founding page picker and the post-signup interstitial.
export default function SeatGrid({ seats, selected, onSelect, busy }) {
  return (
    <div className="grid grid-cols-6 sm:grid-cols-10 gap-1.5" data-testid="founding-grid">
      {seats.map((s) => {
        const isSel = selected === s.seat_number;
        const held = !!s.held || s.status === "held";
        const taken = s.status === "taken" || held;
        const handle = s.username;
        const title = held
          ? "Held for another member"
          : taken
            ? (s.retired ? "Retired seat" : `Taken by @${handle || "member"}`)
            : `Seat #${pad3(s.seat_number)}`;
        return (
          <button
            key={s.seat_number}
            data-testid={`founding-seat-${s.seat_number}`}
            disabled={taken || busy}
            title={title}
            onClick={() => !taken && onSelect(s.seat_number)}
            className={`relative aspect-square flex flex-col items-center justify-center gap-0 font-mono text-[11px] border transition-colors overflow-hidden px-0.5 ${
              taken
                ? "border-sniper bg-obsidian text-muted-foreground/50 cursor-not-allowed"
                : isSel
                  ? "border-[#b08d2c] bg-[#b08d2c] text-white"
                  : "border-sniper text-secondary-foreground hover:border-[#b08d2c] hover:text-foreground"
            }`}
          >
            <span className={taken && !held ? "line-through leading-none" : "leading-none"}>{pad3(s.seat_number)}</span>
            {taken && (held ? (
              <span className="text-[7px] leading-none tracking-wide opacity-80 mt-0.5" data-testid={`founding-seat-holder-${s.seat_number}`}>HELD</span>
            ) : handle ? (
              <span className="text-[7px] leading-none truncate max-w-full opacity-70 mt-0.5" data-testid={`founding-seat-holder-${s.seat_number}`}>@{handle}</span>
            ) : null)}
            {isSel && !taken && <Check className="w-3 h-3 absolute top-0.5 right-0.5" strokeWidth={3} />}
          </button>
        );
      })}
    </div>
  );
}
